// extracted by mini-css-extract-plugin
export default {"tournaments-results-wrapper":"tournamentsResults_tournaments-results-wrapper__7Xjxe","tournament-section-gallery":"tournamentsResults_tournament-section-gallery__6WmQQ"};